import { useNavigate } from "react-router-dom";
import React, { useEffect, useRef } from "react";
import { MdOutlineVerifiedUser, MdClose } from "react-icons/md";
import { Toast } from "../components_root/ToastContext.jsx";
import "../body_root/popup.css";


export default function Upload_file_popup({ data, isOpen, onClose }) {
    const panelRef = useRef(null);
    const { Toastshow } = Toast();
    const navigate = useNavigate();

    // Close on ESC
    useEffect(() => {
        if (!isOpen) return;

        const handleEsc = (e) => {
            if (e.key === "Escape") onClose();
        };

        document.addEventListener("keydown", handleEsc);
        return () => document.removeEventListener("keydown", handleEsc);
    }, [isOpen, onClose]);

    // 🛑 IMPORTANT: Guard render if data not ready
    if (!isOpen || !data || !data.row) return null;

    return (
        <div className={`div-popup-body ${isOpen ? "show" : ""}`}>
            <div
                ref={panelRef}
                className={`overflow-auto div-panel-right ${
                    isOpen ? "slide-in" : "slide-out"
                }`}
            >
                {/* HEADER */}
                <div className="b-bottom items-back">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <div className="button-ui0 text-h2 bold p-2 fcap">
                                        <MdOutlineVerifiedUser className="icon" />
                                        Upload File
                                    </div>
                                </td>
                                <td width={30}>
                                    <div
                                        onClick={onClose}
                                        className="button-ui0 p-2 cursor"
                                    >
                                        <MdClose className="icon" />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* BODY */}
                <div className="p-11">
                    <table>
                        <tbody>
                            <tr>
                                <td className="fcap text-h1 bold">
                                    {data.row.title}
                                </td>
                                <td className="bold text-h3">
                                    {data.description || ""}
                                </td>
                            </tr>

                            <tr>
                                <td className="fcap text-h3">
                                    {data.row.fileshortname} Number:{" "}
                                    <span className="bold">
                                        {data.filenumber}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
